"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDatesToTimespan = transformDatesToTimespan;
const utils_1 = require("@daytrip/utils");
function transformDatesToTimespan(departureAtFrom, departureAtTo) {
    const formattedDepartureAtFrom = (0, utils_1.transformTimeToString)(departureAtFrom, false, true, false);
    const formattedDepartureAtTo = (0, utils_1.transformTimeToString)(departureAtTo);
    return `${formattedDepartureAtFrom}\xa0-\xa0${formattedDepartureAtTo}`;
}
//# sourceMappingURL=transformDatesToTimespan.js.map